module.exports = __webpack_public_path__ + "img/45.1d75729e.jpg";